import type { SiteContent } from "../siteData";

type BookingContactProps = {
  heading: string;
  image: SiteContent["images"]["contact"];
  emails: string[];
};

export function BookingContact({ heading, image, emails }: BookingContactProps) {
  return (
    <section
      className="bookingContact"
      aria-labelledby="booking-contact-heading"
      style={{
        backgroundImage: `linear-gradient(180deg, rgb(0 0 0 / 0.38), rgb(0 0 0 / 0.86)), url(${image})`,
      }}
    >
      <div className="bookingContact__hero">
        <div className="bookingContact__content">
          <span className="bookingContact__eyebrow">Bookings</span>
          <h1 id="booking-contact-heading" className="bookingContact__heading">
            {heading}
          </h1>
          <span className="bookingContact__rule" aria-hidden="true" />
        </div>
      </div>

      <div className="bookingContact__emails" aria-label="Booking email addresses">
        <p className="bookingContact__label">Management and booking inquiries</p>
        {emails.map(email => (
          <a className="bookingContact__email" href={`mailto:${email}`} key={email}>
            <span className="bookingContact__emailIcon" aria-hidden="true">
              @
            </span>
            {email}
          </a>
        ))}
      </div>
    </section>
  );
}
